<template>
  <main class="main page-inside">
    <div class="profile">
      <div class="section profile-section">
        <img src="../images/hero-bg2.jpg" class="bg" alt="" />

        <div class="wrapper">
          <div class="title big title-main">My profile</div>

          <div class="profile-content">
            <!-- PROFILE -->
            <div class="profile-info">
              <div class="avatar">
                <img
                  v-if="$parent.profileData"
                  :src="$parent.profileData.avatar"
                  class="img"
                  alt="Avatar"
                />
              </div>

              <div class="text">
                <div class="row">
                  <div class="title small">Name:</div>
                  <div class="desc">
                    {{ $parent.profileData && $parent.profileData.name }}
                  </div>
                </div>

                <div class="row">
                  <div class="title small">Steam ID:</div>
                  <div class="desc">
                    {{ $parent.profileData && $parent.profileData.steam_id }}
                  </div>
                </div>
              </div>

              <div class="balance-block">
                <div class="balance-block-wrapper">
                  <div class="title small">BALANCE:</div>

                  <div class="title amount">
                    {{
                      $parent.profileData && $parent.profileData.balance != null
                        ? $parent.profileData.balance
                        : '0.00'
                    }}
                    <span class="currency">
                      {{ $parent.currency }}
                    </span>
                  </div>

                  <div class="button" @click="$parent.openTopUpModal">
                    Top up balance
                  </div>
                </div>
              </div>

              <button
                type="button"
                class="button black"
                @click="$parent.logout"
              >
                <span>LOG OUT</span>
              </button>
            </div>

            <!-- HISTORY -->
            <div class="tables">
              <div class="title tables-title">History</div>

              <div class="history-info">
                <!-- PURCHASES -->
                <template
                  v-if="$parent.orderHistory && $parent.orderHistory.length"
                >
                  <div class="title medium">Items</div>

                  <div class="table-container">
                    <table>
                      <thead>
                        <tr>
                          <td>Date</td>
                          <td>Item</td>
                          <td>Count</td>
                          <td>Total price</td>
                          <td>Status</td>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, i) in $parent.orderHistory"
                          :key="'order-' + i"
                        >
                          <td>{{ $parent.formatDate(item.date) }}</td>
                          <td>
                            <div
                              v-for="(purchasedItem, index) in item.items || []"
                              :key="index"
                            >
                              {{
                                purchasedItem.display_name ||
                                purchasedItem.name ||
                                'Rust item'
                              }}
                            </div>
                          </td>

                          <td>
                            <div
                              v-for="(purchasedItem, index) in item.items || []"
                              :key="index"
                            >
                              {{ purchasedItem.count || 1 }}
                            </div>
                          </td>
                          <td>
                            <b>
                              {{ item.total_price }}
                              {{ item.currency }}
                            </b>
                          </td>
                          <td>{{ item.status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>

                <!-- TOP UPS -->
                <template
                  v-if="$parent.depositHistory && $parent.depositHistory.length"
                >
                  <div class="title medium">Top Up</div>

                  <div class="table-container">
                    <table>
                      <thead>
                        <tr>
                          <td>Date</td>
                          <td>Amount</td>
                          <td>Status</td>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(item, i) in $parent.depositHistory"
                          :key="'deposit-' + i"
                        >
                          <td>{{ $parent.formatDate(item.date) }}</td>
                          <td>
                            {{ item.amount }}
                            {{ item.currency }}
                          </td>
                          <td>{{ item.status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </template>

                <!-- SELL OFFERS -->
                <div class="profile-history-section">
                  <div class="profile-history-heading">
                    <div class="title medium">Sell offers</div>

                    <div class="profile-history-actions">
                      <button
                        type="button"
                        class="profile-small-button"
                        :disabled="offersLoading"
                        @click="fetchSellOffers"
                      >
                        Refresh
                      </button>

                      <button
                        v-if="$parent.canSellSkins"
                        type="button"
                        class="profile-small-button primary"
                        @click="$parent.openSellSkins"
                      >
                        Sell skins
                      </button>
                    </div>
                  </div>

                  <p v-if="offersError" class="profile-error">
                    {{ offersError }}
                  </p>

                  <p v-if="offerMessage" class="profile-success">
                    {{ offerMessage }}
                  </p>

                  <div
                    v-if="offersLoading && !sellOffers.length"
                    class="profile-empty"
                  >
                    Loading...
                  </div>

                  <div
                    v-else-if="!sellOffers.length && !offersError"
                    class="profile-empty"
                  >
                    No sell offers yet.
                  </div>

                  <div
                    v-else-if="sellOffers.length"
                    class="table-container profile-table-container"
                  >
                    <table class="profile-simple-table">
                      <thead>
                        <tr>
                          <td>Offer</td>
                          <td>Date</td>
                          <td>Items</td>
                          <td>Amount</td>
                          <td>Status</td>
                          <td></td>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(offer, index) in sellOffers"
                          :key="offer.id || index"
                        >
                          <td>
                            <strong class="profile-accent">
                              #{{ offer.id || index + 1 }}
                            </strong>
                          </td>

                          <td class="profile-date">
                            {{ formatDate(offer.created_at) }}
                          </td>

                          <!-- SHOW EVERY SOLD ITEM -->
                          <td>
                            <div class="profile-offer-items">
                              <div
                                v-for="(item, itemIndex) in offerItems(offer)"
                                :key="itemIndex"
                                class="profile-offer-item"
                              >
                                <span class="profile-item-name">
                                  {{ itemName(item, offer) }}
                                </span>

                                <strong class="profile-item-quantity">
                                  ×{{ itemQuantity(item) }}
                                </strong>
                              </div>
                            </div>
                          </td>

                          <td class="profile-amount">
                            {{ offerTotal(offer) }}
                            {{ offer.currency || $parent.currency }}
                          </td>

                          <td>
                            <span :class="statusClass(offer.status)">
                              {{ statusLabel(offer.status) }}
                            </span>
                          </td>

                          <td>
                            <button
                              v-if="isCounteroffer(offer)"
                              type="button"
                              class="profile-small-button primary"
                              :disabled="respondingOfferId !== null"
                              @click="openOfferModal(offer)"
                            >
                              Review
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <!-- WITHDRAWALS -->
                <div class="profile-history-section">
                  <div class="profile-history-heading">
                    <div class="title medium">Withdrawals</div>

                    <button
                      type="button"
                      class="profile-small-button"
                      :disabled="payoutLoading"
                      @click="loadPayouts"
                    >
                      Refresh
                    </button>
                  </div>

                  <p
                    v-if="payoutError && !withdrawModalOpen"
                    class="profile-error"
                  >
                    {{ payoutError }}
                  </p>

                  <p v-if="withdrawMessage" class="profile-success">
                    {{ withdrawMessage }}
                  </p>

                  <!-- NEW WITHDRAW BUTTON -->
                  <div class="profile-withdraw-launch">
                    <span class="profile-muted">
                      Seller payout balance:
                      <strong>
                        {{
                          sellerBalance === null
                            ? 'Unavailable'
                            : money(sellerBalance) +
                              ' ' +
                              ($parent.currency || 'EUR')
                        }}
                      </strong>
                    </span>

                    <button
                      type="button"
                      class="profile-small-button primary"
                      :disabled="!canWithdraw || withdrawSubmitting"
                      @click="openWithdrawModal"
                    >
                      WITHDRAW
                    </button>
                  </div>

                  <!-- WITHDRAWAL HISTORY -->
                  <div
                    v-if="payoutLoading && !payoutHistory.length"
                    class="profile-empty"
                  >
                    Loading...
                  </div>

                  <div
                    v-else-if="!payoutHistory.length && !payoutError"
                    class="profile-empty"
                  >
                    No withdrawals yet.
                  </div>

                  <div
                    v-else-if="payoutHistory.length"
                    class="table-container profile-table-container"
                  >
                    <table class="profile-simple-table">
                      <thead>
                        <tr>
                          <td>Date</td>
                          <td>Amount</td>
                          <td>Status</td>
                          <td>Action</td>
                        </tr>
                      </thead>

                      <tbody>
                        <tr
                          v-for="(payout, index) in payoutHistory"
                          :key="payout.id || index"
                        >
                          <td>
                            {{ formatDate(payout.created_at) }}
                          </td>

                          <td class="profile-amount">
                            {{ money(payout.amount) }}
                            {{ payout.currency || $parent.currency }}
                          </td>

                          <td>
                            <span :class="statusClass(payout.status)">
                              {{ statusLabel(payout.status) }}
                            </span>
                          </td>
                          <td>
                            <button
                              v-if="
                                String(payout.status).toLowerCase() ===
                                'approved'
                              "
                              type="button"
                              class="profile-small-button primary"
                              :disabled="withdrawSubmitting"
                              @click="continueApprovedPayout(payout)"
                            >
                              CONTINUE PAYOUT
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- COUNTEROFFER MODAL -->
    <ProfileActionModal
      v-if="activeModal"
      :action="activeModal.action"
      :offer="activeModal.offer"
      :amount="activeModal.amount"
      :currency="activeModal.currency"
      :loading="respondingOfferId !== null"
      @close="closeModal"
      @confirm="confirmModal"
    />

    <!-- NEW RUSTLEGACYS-STYLE WITHDRAWAL MODAL -->
    <WithdrawModal
      v-if="withdrawModalOpen"
      :currency="$parent.currency || 'EUR'"
      :balance="sellerBalance"
      :continuation="!!payoutContinuation"
      :approved-amount="payoutContinuation ? payoutContinuation.amount : null"
      :enabled-methods="enabledPayoutMethods"
      :loading="withdrawSubmitting"
      :error="payoutError"
      @close="closeWithdrawModal"
      @submit="submitWithdrawalDetails"
    />
  </main>
</template>

<script>
import ProfileActionModal from '../components/ProfileActionModal.vue'
import WithdrawModal from '../components/WithdrawModal.vue'

export default {
  name: 'Profile',

  components: {
    ProfileActionModal,
    WithdrawModal,
  },

  data() {
    return {
      sellOffers: [],
      offersLoading: false,
      offersError: '',
      offerMessage: '',
      respondingOfferId: null,

      payoutHistory: [],
      payoutLoading: false,
      payoutError: '',
      withdrawSubmitting: false,
      withdrawMessage: '',
      withdrawModalOpen: false,
      payoutContinuation: null,

      activeModal: null,
    }
  },

  computed: {
    sellerBalance() {
      const profile = this.$parent.profileData

      if (
        profile &&
        profile.payout_balance !== undefined &&
        profile.payout_balance !== null
      ) {
        return profile.payout_balance
      }

      return null
    },
    payoutsEnabled() {
      const settings = this.$parent.settings || {}

      const enabled = (value) =>
        value === true || value === 1 || value === '1' || value === 'true'

      return enabled(this.$parent.isAuth) && enabled(settings.payout_enabled)
    },

    enabledPayoutMethods() {
      const settings = this.$parent.settings || {}

      if (!this.payoutsEnabled) return []

      const configured = settings.payout_methods

      const methods = Array.isArray(configured)
        ? configured
        : configured && typeof configured === 'object'
          ? Object.values(configured)
          : []

      const aliases = {
        'card-form': 'card-form',
        card: 'card-form',
        visa: 'card-form',
        'visa-card': 'card-form',
        'sepa-manual': 'sepa-manual',
        sepa: 'sepa-manual',
        bank: 'sepa-manual',
        'bank-transfer': 'sepa-manual',
      }

      const enabled = methods
        .filter((item) => {
          if (!item || typeof item !== 'object') return true

          return (
            ![false, 0, '0', 'false'].includes(item.enabled) &&
            ![false, 0, '0', 'false'].includes(item.is_enabled)
          )
        })
        .map((item) => {
          const raw =
            typeof item === 'string'
              ? item
              : item.code ||
                item.slug ||
                item.type ||
                item.value ||
                item.id ||
                ''

          return aliases[String(raw).trim().toLowerCase()] || ''
        })
        .filter(Boolean)

      return [...new Set(enabled)]
    },

    canWithdraw() {
      return (
        this.payoutsEnabled &&
        this.enabledPayoutMethods.length > 0 &&
        this.sellerBalance !== null &&
        Number(this.sellerBalance) > 0
      )
    },
  },

  mounted() {
    this.fetchSellOffers()
    this.loadPayouts()
  },

  methods: {
    money(value) {
      const number = Number(value)
      return Number.isFinite(number) ? number.toFixed(2) : '0.00'
    },

    formatDate(value) {
      if (!value) return ''

      const numeric = Number(value)

      const date =
        Number.isFinite(numeric) && numeric > 0
          ? new Date(numeric < 1000000000000 ? numeric * 1000 : numeric)
          : new Date(value)

      return Number.isNaN(date.getTime()) ? '' : date.toLocaleDateString()
    },

    statusLabel(status) {
      const labels = {
        CounterOffer: 'Counteroffer',
        UserDeclined: 'Declined',
      }

      return labels[status] || String(status || 'Pending').replace(/_/g, ' ')
    },

    statusClass(status) {
      const value = String(status || '').toLowerCase()

      if (
        value.includes('completed') ||
        value.includes('approved') ||
        value.includes('paid')
      ) {
        return 'profile-status-success'
      }

      if (
        value.includes('declin') ||
        value.includes('reject') ||
        value.includes('cancel') ||
        value.includes('fail')
      ) {
        return 'profile-status-error'
      }

      return 'profile-status-pending'
    },

    offerItems(offer) {
      if (Array.isArray(offer.items)) {
        return offer.items
      }

      if (offer.items && Array.isArray(offer.items.data)) {
        return offer.items.data
      }

      return []
    },

    itemQuantity(item) {
      if (item.quantity !== undefined && item.quantity !== null) {
        return item.quantity
      }

      if (item.amount !== undefined && item.amount !== null) {
        return item.amount
      }

      return 1
    },

    itemName(item, offer) {
      if (item.display_name || item.game_name || item.name) {
        return item.display_name || item.game_name || item.name
      }

      const snapshot = Array.isArray(offer.inventory_snapshot)
        ? offer.inventory_snapshot
        : []

      const match = snapshot.find(
        (entry) =>
          entry.short_name === item.short_name &&
          (item.skin === undefined ||
            entry.skin === undefined ||
            String(entry.skin) === String(item.skin)),
      )

      return (
        (match && (match.display_name || match.game_name || match.name)) ||
        item.short_name ||
        'Rust item'
      )
    },

    offerTotal(offer) {
      const value =
        offer.total_amount !== undefined && offer.total_amount !== null
          ? offer.total_amount
          : offer.total_price !== undefined && offer.total_price !== null
            ? offer.total_price
            : offer.total

      if (value !== undefined && value !== null) {
        return this.money(value)
      }

      const total = this.offerItems(offer).reduce((sum, item) => {
        return sum + Number(this.itemQuantity(item)) * Number(item.price || 0)
      }, 0)

      return total.toFixed(2)
    },

    isCounteroffer(offer) {
      return (
        String(offer.status || '').toLowerCase() === 'counteroffer' &&
        offer.id !== undefined &&
        offer.id !== null &&
        offer.counter_offer_amount !== null &&
        offer.counter_offer_amount !== undefined
      )
    },

    openOfferModal(offer) {
      if (!this.isCounteroffer(offer) || this.respondingOfferId !== null) {
        return
      }

      this.offersError = ''

      this.activeModal = {
        action: 'offer',
        offer: offer,
        amount: '',
        currency: offer.currency || this.$parent.currency || 'EUR',
      }
    },

    closeModal() {
      if (this.respondingOfferId !== null) {
        return
      }

      this.activeModal = null
    },

    confirmModal(action) {
      if (!this.activeModal) return

      if (
        this.activeModal.action === 'offer' &&
        (action === 'accept' || action === 'decline')
      ) {
        this.respondToOffer(this.activeModal.offer, action)
      }
    },

    async fetchSellOffers() {
      if (this.offersLoading) return

      this.offersLoading = true
      this.offersError = ''

      try {
        const response = await this.$http.get(
          process.env.VUE_APP_API + 'user/sell-requests',
        )

        const data = response.data || {}
        const payload = data.payload || data.data || []

        if (Array.isArray(payload)) {
          this.sellOffers = payload
        } else if (payload && Array.isArray(payload.data)) {
          this.sellOffers = payload.data
        } else if (payload && Array.isArray(payload.items)) {
          this.sellOffers = payload.items
        } else {
          this.sellOffers = []
        }
      } catch (error) {
        this.offersError =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Could not load sell offers.'
      } finally {
        this.offersLoading = false
      }
    },

    async respondToOffer(offer, action) {
      if (
        !this.isCounteroffer(offer) ||
        this.respondingOfferId !== null ||
        (action !== 'accept' && action !== 'decline')
      ) {
        return
      }

      this.respondingOfferId = offer.id
      this.offersError = ''
      this.offerMessage = ''

      try {
        const endpoint = action === 'accept' ? 'approve' : 'decline'

        const response = await this.$http.post(
          process.env.VUE_APP_API +
            'user/sell-requests/' +
            encodeURIComponent(offer.id) +
            '/' +
            endpoint,
        )

        if (!response.data || response.data.status !== 'OK') {
          throw new Error(
            (response.data && response.data.message) || 'Request failed.',
          )
        }

        this.activeModal = null

        this.offerMessage =
          action === 'accept' ? 'Offer accepted.' : 'Offer declined.'

        await this.fetchSellOffers()
        await this.loadPayouts()
      } catch (error) {
        this.offersError =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          'Request failed.'

        this.activeModal = null
      } finally {
        this.respondingOfferId = null
      }
    },

    async loadPayouts() {
      if (this.payoutLoading) return

      this.payoutLoading = true
      this.payoutError = ''

      try {
        const response = await this.$http.get(
          process.env.VUE_APP_API + 'user/withdraw-requests',
        )

        const data = response.data || {}
        const payload = data.payload || data.data || []

        this.payoutHistory = Array.isArray(payload)
          ? payload
          : payload && Array.isArray(payload.data)
            ? payload.data
            : []
      } catch (error) {
        this.payoutError =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          'Could not load withdrawals.'
      } finally {
        this.payoutLoading = false
      }
    },

    openWithdrawModal() {
      if (!this.canWithdraw || this.withdrawSubmitting) {
        return
      }

      this.payoutError = ''
      this.withdrawMessage = ''
      this.payoutContinuation = null
      this.withdrawModalOpen = true
    },

    continueApprovedPayout(payout) {
      if (this.withdrawSubmitting || !payout || !payout.id) return
      this.payoutError = ''
      this.withdrawMessage = ''
      this.payoutContinuation = payout
      this.withdrawModalOpen = true
    },

    closeWithdrawModal() {
      if (this.withdrawSubmitting) return

      this.withdrawModalOpen = false
      this.payoutContinuation = null
      this.payoutError = ''
    },

    async submitWithdrawalDetails(details) {
      if (this.withdrawSubmitting) return

      this.payoutError = ''
      this.withdrawMessage = ''

      const form = details && details.details ? details.details : {}

      const amountText = String(
        details && details.amount != null ? details.amount : '',
      ).trim()

      const amount = Number(amountText)
      const method = details && details.method

      // Check enabled payout methods.
      if (
        (!this.payoutContinuation && !this.canWithdraw) ||
        !this.enabledPayoutMethods.includes(method)
      ) {
        this.payoutError = 'This payout method is not currently available.'
        return
      }

      // Validate amount.
      if (
        !/^\d+(\.\d{1,2})?$/.test(amountText) ||
        !Number.isFinite(amount) ||
        amount <= 0
      ) {
        this.payoutError = 'Please enter a valid withdrawal amount.'
        return
      }

      if (
        !this.payoutContinuation &&
        (this.sellerBalance === null || amount > Number(this.sellerBalance))
      ) {
        this.payoutError = 'Insufficient seller payout balance.'
        return
      }

      if (method !== 'card-form' && method !== 'sepa-manual') {
        this.payoutError = 'Please select a payout method.'
        return
      }

      // Validate personal information.
      const requiredFields = [
        'email',
        'name',
        'surname',
        'phone',
        'country',
        'city',
        'address',
        'postCode',
      ]

      for (const field of requiredFields) {
        if (!String(form[field] || '').trim()) {
          this.payoutError = 'Please complete all personal details.'
          return
        }
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(form.email).trim())) {
        this.payoutError = 'Invalid email address.'
        return
      }

      // Prepare withdrawal request.
      const payload = {
        amount: amount,
        method: method,
        email: String(form.email).trim(),
        name: String(form.name).trim(),
        surname: String(form.surname).trim(),
        phone: String(form.phone).trim(),
        country: form.country,
        city: String(form.city).trim(),
        address: String(form.address).trim(),
        postCode: String(form.postCode).trim(),
      }

      // SEPA details.
      if (method === 'sepa-manual') {
        const iban = String(form.account_number || '')
          .replace(/\s/g, '')
          .toUpperCase()

        if (!/^[A-Z]{2}[0-9A-Z]{13,32}$/.test(iban)) {
          this.payoutError = 'Please enter a valid IBAN.'
          return
        }

        if (
          !String(form.first_name || '').trim() ||
          !String(form.last_name || '').trim()
        ) {
          this.payoutError = 'Please enter the bank account holder name.'
          return
        }

        payload.account_number = iban
        payload.first_name = String(form.first_name).trim()
        payload.last_name = String(form.last_name).trim()
      }

      this.withdrawSubmitting = true

      try {
        if (this.payoutContinuation) {
          const requestId = this.payoutContinuation.id
          const payoutDetails = {
            email: payload.email,
            name: payload.name,
            surname: payload.surname,
            phone: payload.phone,
            country: payload.country,
            currency:
              this.payoutContinuation.currency ||
              this.$parent.currency ||
              'EUR',
            city: payload.city,
            address: payload.address,
            postCode: payload.postCode,
          }
          if (method === 'sepa-manual') {
            payoutDetails.account_number = payload.account_number
            payoutDetails.first_name = payload.first_name
            payoutDetails.last_name = payload.last_name
          }

          const payoutResponse = await this.$http.post(
            process.env.VUE_APP_API +
              'user/withdraw-requests/' +
              encodeURIComponent(requestId) +
              '/payout/' +
              method,
            payoutDetails,
          )
          const payoutResult = payoutResponse.data || {}
          if (payoutResult.status !== 'OK') {
            throw new Error(payoutResult.message || 'Could not start payout.')
          }
          if (method === 'card-form') {
            const redirect = payoutResult.redirect_url
            if (
              typeof redirect !== 'string' ||
              !/^https:\/\//i.test(redirect)
            ) {
              throw new Error(
                'The payment provider did not return a secure redirect URL.',
              )
            }
            window.location.assign(redirect)
            return
          }
          this.withdrawMessage =
            payoutResult.message || 'Bank payout submitted.'
        } else {
          // Creating a request does not initiate a payout.
          const response = await this.$http.post(
            process.env.VUE_APP_API + 'user/withdraw-requests',
            { amount },
          )
          const result = response.data || {}
          if (result.status !== 'OK') {
            throw new Error(result.message || 'Withdrawal request failed.')
          }
          this.withdrawMessage =
            'Withdrawal request submitted. Waiting for admin review.'
        }

        this.withdrawModalOpen = false
        this.payoutContinuation = null
        await this.loadPayouts()
      } catch (error) {
        const data = error.response && error.response.data

        let message =
          (data && data.message) ||
          error.message ||
          'Withdrawal request failed.'

        if (data && data.errors) {
          const firstKey = Object.keys(data.errors)[0]
          const firstError = data.errors[firstKey]

          if (Array.isArray(firstError) && firstError.length) {
            message = firstError[0]
          }
        }

        this.payoutError = message
      } finally {
        this.withdrawSubmitting = false
      }
    },
  },
}
</script>

<style scoped>
.profile-history-section {
  margin-top: 35px;
}

.profile-history-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 16px;
}

.profile-history-heading .title {
  margin: 0;
}

.profile-history-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* WEBSITE-STYLE BUTTONS */
.profile-history-section .profile-small-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 38px;
  margin: 0;
  padding: 8px 15px;
  border: 1px solid #554040;
  border-radius: 0;
  background: transparent;
  color: #fff;
  font-family: 'Bebas Neue', Impact, sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 1.2;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  box-sizing: border-box;
}

.profile-history-section .profile-small-button.primary {
  background: #d94d32;
  border-color: #d94d32;
}

.profile-history-section .profile-small-button:hover {
  border-color: #e15d40;
}

.profile-history-section .profile-small-button.primary:hover {
  background: #ed6547;
}

.profile-history-section .profile-small-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* TABLE */
.profile-table-container {
  width: 100%;
  overflow-x: auto;
}

.profile-simple-table {
  width: 100%;
  min-width: 680px;
  border-collapse: collapse;
}

.profile-simple-table thead {
  background: #282121;
}

.profile-simple-table td {
  padding: 14px 12px;
  border-bottom: 1px solid #423333;
  color: #ddd;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 12px;
  line-height: 1.6;
  vertical-align: middle;
}

.profile-simple-table thead td {
  color: #aaa;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 11px;
  font-weight: 600;
}

.profile-date {
  white-space: nowrap;
}

.profile-accent {
  color: #e15d40;
}

.profile-amount {
  color: #fff !important;
  font-weight: 700;
  white-space: nowrap;
}

.profile-muted {
  color: #888;
  font-family: 'Open Sans', Arial, sans-serif;
}

/* ALL SOLD ITEMS */
.profile-offer-items {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 150px;
  max-width: 280px;
}

.profile-offer-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.profile-item-name {
  min-width: 0;
  color: #ddd;
  overflow-wrap: break-word;
}

.profile-item-quantity {
  flex-shrink: 0;
  color: #fff;
  white-space: nowrap;
}

/* STATUS */
.profile-status-success {
  color: #80c996;
}

.profile-status-error,
.profile-error {
  color: #ef8989;
}

.profile-status-pending {
  color: #e4b26e;
}

.profile-success {
  color: #80c996;
}

.profile-error,
.profile-success {
  margin: 10px 0;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 12px;
}

.profile-empty {
  padding: 18px 0;
  color: #aaa;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 12px;
}

/* NEW WITHDRAW BUTTON SECTION */
.profile-withdraw-launch {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin: 15px 0 25px;
  padding: 15px 0;
  border-bottom: 1px solid #423333;
}

.profile-withdraw-launch .profile-muted {
  color: #aaa;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 13px;
}

/* MOBILE */
@media (max-width: 700px) {
  .profile-history-heading {
    align-items: flex-start;
    flex-direction: column;
  }

  .profile-history-actions {
    flex-wrap: wrap;
  }

  .profile-simple-table {
    min-width: 680px;
  }
}

@media (max-width: 400px) {
  .profile-withdraw-launch {
    align-items: flex-start;
    flex-direction: column;
  }

  .profile-withdraw-launch .profile-small-button {
    width: 100%;
  }
}
</style>
